/** Line icons for action buttons (16-unit grid, stroke = currentColor), matching BellIcon's style. */

const PATHS: Record<string, JSX.Element> = {
  run: <path d="M5 3.5v9l7.5-4.5z" />,
  rerun: <><path d="M13 8a5 5 0 1 1-1.5-3.6" /><path d="M13 2.8v2.7h-2.7" /></>,
  stop: <rect x="4" y="4" width="8" height="8" rx="1.2" />,
  edit: <><path d="M10.5 2.8l2.7 2.7-7.5 7.5H3v-2.7z" /><path d="M9 4.3l2.7 2.7" /></>,
  reuse: <><rect x="5.5" y="5.5" width="7.5" height="7.5" rx="1.4" /><path d="M3 10.5V4a1 1 0 0 1 1-1h6.5" /></>,
  trash: <><path d="M3 4.5h10" /><path d="M6.5 4.5V3h3v1.5" /><path d="M4.5 4.5l.6 8.5h5.8l.6-8.5" /></>,
  push: <><path d="M8 12.5V4" /><path d="M4.5 7.5L8 4l3.5 3.5" /><path d="M3.5 14h9" /></>,
  discard: <><path d="M4 4l8 8" /><path d="M12 4l-8 8" /></>,
  expand: <path d="M4 6l4 4 4-4" />,
  collapse: <path d="M4 10l4-4 4 4" />,
  minimize: <path d="M3.5 8h9" />,
  fork: <><circle cx="4.5" cy="3.5" r="1.4" /><circle cx="4.5" cy="12.5" r="1.4" /><circle cx="11.5" cy="5.5" r="1.4" />
          <path d="M4.5 4.9v6.2" /><path d="M11.5 6.9c0 2.6-7 1.6-7 4.2" /></>,
  close: <><path d="M4 4l8 8" /><path d="M12 4l-8 8" /></>,
  addRows: <><rect x="2.5" y="2.5" width="11" height="11" rx="1.6" /><path d="M2.5 6.2h11" /><path d="M2.5 9.8h5" />
             <path d="M11 8.8v3.6" /><path d="M9.2 10.6h3.6" /></>,
};

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 15 }: { name: IconName; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={1.6}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
      {PATHS[name]}
    </svg>
  );
}

/** An icon-only button: the label is the tooltip and what screen readers announce. */
export function IconButton({ icon, label, className = "", onClick, disabled, size, expanded }: {
  icon: IconName; label: string; className?: string; onClick: (e: React.MouseEvent) => void;
  disabled?: boolean; size?: number; expanded?: boolean;
}) {
  return (
    <button type="button" className={`icon-only ${className}`.trim()} title={label} aria-label={label}
            aria-expanded={expanded} disabled={disabled} onClick={onClick}>
      <Icon name={icon} size={size} />
    </button>
  );
}
